'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Rowing = function (_PureComponent) {
  (0, _inherits3.default)(Rowing, _PureComponent);
  function Rowing() {
    (0, _classCallCheck3.default)(this, Rowing);
    return (0, _possibleConstructorReturn3.default)(this, (Rowing.__proto__ || (0, _getPrototypeOf2.default)(Rowing)).apply(this, arguments));
  }
  (0, _createClass3.default)(Rowing, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 27 32',
        style: {
          width: '0.84375em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M26.3 27.512c-.248-.408-.792-1.33-1.422-2.398a466.51 466.51 0 0 0-2.698-4.536c-.736-1.21-2.216-2.086-3.524-2.86-1.034-.614-2.012-1.192-2.374-1.79L14.2 12.512l6.944-11.444a.703.703 0 1 0-1.202-.73c-.054.092-3.79 6.224-6.576 10.8L6.786.338a.702.702 0 1 0-1.2.73l6.944 11.444-2.08 3.416c-.364.598-1.34 1.176-2.376 1.79-1.306.774-2.788 1.652-3.524 2.86a491.86 491.86 0 0 0-2.698 4.536A352.366 352.366 0 0 1 .43 27.512c-.286.47-.572 1.024-.354 1.668.206.608.822 1.198 1.994 1.91s1.98.988 2.614.89c.672-.102 1.032-.612 1.318-1.082.248-.408.816-1.316 1.474-2.366.924-1.476 2.074-3.312 2.786-4.484.736-1.21.832-2.928.918-4.444.068-1.2.132-2.334.496-2.932.218-.356.85-1.398 1.69-2.784l1.69 2.784c.364.598.428 1.732.494 2.932.086 1.516.182 3.236.918 4.444.712 1.172 1.862 3.008 2.786 4.484.658 1.05 1.226 1.958 1.474 2.366.286.47.646.98 1.318 1.082.634.096 1.44-.178 2.614-.89s1.788-1.302 1.994-1.91c.218-.642-.068-1.198-.354-1.668z'
      }));
    }
  }]);
  return Rowing;
}(_react.PureComponent);
Rowing.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Rowing;